import React, { useState } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { ClassNameMap } from '@material-ui/styles';
import { OutlinedInputClassKey } from '@material-ui/core/OutlinedInput';

import RenderTextField, { RenderTextFieldProps } from 'shared/forms/render-text-field';

import { useStyles } from './styles';

export type PasswordInputFieldProps = RenderTextFieldProps & {
  bordered?: boolean;
};

export const PasswordInputField = ({
  InputProps,
  inputProps,
  bordered = true,
  label,
  ...props
}: PasswordInputFieldProps) => {
  const classes = useStyles({ bordered });
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
  };
  const togglePassword = () => setShowPassword(!showPassword);

  return (
    <RenderTextField
      {...props}
      variant="standard"
      type={showPassword ? 'text' : 'password'}
      inputProps={{
        'data-testid': props.name,
        ...inputProps,
      }}
      InputProps={{
          ...InputProps,
        classes: { root: classes.input, underline: classes.underline, ...InputProps?.classes } as Partial<ClassNameMap<OutlinedInputClassKey>>,
        endAdornment: (
          <InputAdornment position="end" className={classes.iconPassword}>
            <IconButton
              aria-label="toggle password visibility"
              onClick={togglePassword}
              onMouseDown={handleMouseDown}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),

      }}
      customLabel={
        <label htmlFor={props.name} className={classes.label}>
          {label}
        </label>
      }
    />
  );
};
